module.exports = __webpack_public_path__ + "img/lukasz_kaczmarek_profile_picturejpg.8ccc81d5.jpg";